import { render, staticRenderFns } from "./contact_us.vue?vue&type=template&id=0d889194&scoped=true"
import script from "./contact_us.vue?vue&type=script&lang=js"
export * from "./contact_us.vue?vue&type=script&lang=js"
import style0 from "./contact_us.vue?vue&type=style&index=0&id=0d889194&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d889194",
  null
  
)

export default component.exports